import {useQuery} from "@tanstack/react-query";
import {getUserLastConnection} from "../services/account/getUserLastConnection.service";

const useGetUserLastConnection = () => {
  return useQuery({
    queryKey: ["userLastConnection"],
    queryFn: getUserLastConnection,
    staleTime: Number.POSITIVE_INFINITY, // Doesn't change during session
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    select: response => {
      return response?.data;
    },
  });
};

export default useGetUserLastConnection;
